import request from '@/utils/request'

//用户登录
export function userLogin(data) {
    return request({
        url: '/apiuser/Login/do_login',
        method: 'post',
        data
    })
}
// 获取用户当前会员剩余时长
export function getusertime(data) {
    return request({
        url: '/apiuser/User/checkLeftTime',
        method: 'post',
        data
    })
}
// 获取项目列表
export function getprolist(params) {
    return request({
        url: '/apiuser/Project/lists',
        method: 'get',
        params: {
            ...params
        }
    })
}
// 获取模版列表
export function gettemplist(params) {
    return request({
        url: '/apiuser/Template/lists',
        method: 'get',
        params: {
            ...params
        }
    })
}
// 创建项目
export function addpro(data) {
    return request({
        url: '/apiuser/Project/adds',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取项目详情
export function getprodel(params) {
    return request({
        url: '/apiuser/Project/details',
        method: 'get',
        params: {
            ...params
        }
    })
}
// 获取模版详情
export function getTempdel(params) {
    return request({
        url: '/apiuser/Template/details',
        method: 'post',
        data: {
            ...params
        }
    })
}
// 获取组件应用类别列表
export function getZjSort(params) {
    return request({
        url: '/apiuser/ZjSort/lists',
        method: 'get',
        params: {
            params
        }
    })
}
// 获取组件样式类别列表
export function getZjLevel(params) {
    return request({
        url: '/apiuser/ZjLevel/lists',
        method: 'get',
        params: {
            params
        }
    })
}
// 获取组件列表
export function getZujian_list(params) {
    return request({
        url: '/apiuser/ZuJian/lists',
        method: 'get',
        params: {
            ...params
        }
    })
}
// 更新项目配置
export function update_pro(data) {
    return request({
        url: '/apiuser/Project/updates',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 更新项目名称
export function update_proname(data) {
    return request({
        url: '/apiuser/Project/updateName',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 删除项目
export function delete_pro(data) {
    return request({
        url: '/apiuser/Project/deletes',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取头尾列表
export function ZujianTb_list(params) {
    return request({
        url: '/apiuser/ZuJianTb/lists',
        method: 'get',
        params: {
            ...params
        }
    })
}
// 获取标签列表
export function ZujianLbl_list(params) {
    return request({
        url: '/apiuser/ZuJianLbl/lists',
        method: 'get',
        params: {
            ...params
        }
    })
}
// 项目分享
export function shareProject(params) {
    return request({
        url: 'apiuser/Project/shares',
        method: 'post',
        data: {
            ...params
        }
    })
}
// 更新/上传组件数据
export function prodataupdate(data) {
    return request({
        url: 'apiuser/ProjectData/updates',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取组件数据
export function getprodata(data) {
    return request({
        url: 'apiuser/ProjectData/details',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 更新/上传组件弹窗数据
export function prologdataupdate(data) {
    return request({
        url: 'apiuser/ProjectDialog/updates',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取组件弹窗数据
export function getprologdata(data) {
    return request({
        url: 'apiuser/ProjectDialog/details',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取组件弹窗数据(shares)
export function getprologdatashare(data) {
    return request({
        url: 'apiuser/ProjectDialog/shares',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 根据id获取头尾组件
export function getTbById(data) {
    return request({
        url: 'apiuser/ZuJianTb/details',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 根据id获取标签组件
export function getLblById(data) {
    return request({
        url: 'apiuser/ZuJianLbl/details',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取我的组件列表
export function getMyComp(data) {
    return request({
        url: 'apiuser/UserZuJian/lists',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 分享项目
export function proshare(data) {
    return request({
        url: 'apiuser/Project/shares',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 新增我的组件
export function userZjadd(data) {
    return request({
        url: 'apiuser/UserZuJian/adds',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 删除我的组件
export function userZjdel(data) {
    return request({
        url: 'apiuser/UserZuJian/deletes',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 修改我的组件数据
export function userZjUpdate(data) {
    return request({
        url: 'apiuser/UserZuJian/updatedatas',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取我的组件配置数据
export function getZjData(data) {
    return request({
        url: 'apiuser/UserZuJian/configdetails',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取我的组件excel数据
export function getZjExcel(data) {
    return request({
        url: 'apiuser/UserZuJian/datadetails',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 更新我的组件名称与配置
export function updateMyConfig(data) {
    return request({
        url: 'apiuser/UserZuJian/updates',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 我的组件名称修改
export function updateZjName(data) {
    return request({
        url: 'apiuser/UserZuJian/updatenames',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 用户注册
export function doreg(data) {
    return request({
        url: 'apiuser/Login/do_reg',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取会员套餐列表
export function getMemberPrice(data) {
    return request({
        url: 'apiuser/Goods/lists',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取套餐详情
export function getMemPridetail(data) {
    return request({
        url: 'apiuser/Goods/details',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 生成付款二维码
export function buildCode(data) {
    return request({
        url: 'apiuser/Wx/wxpayQrcode',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取用户信息
export function getUserinfo(data) {
    return request({
        url: 'apiuser/User/details',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 修改用户信息
export function updateUserinfo(data) {
    return request({
        url: 'apiuser/User/updates',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取订单列表
export function getorderlist(data) {
    return request({
        url: 'apiuser/PayOrder/lists',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取订单状态
export function getOrderStatus(data) {
    return request({
        url: 'apiuser/PayOrder/checkOrderPay',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 检查用户权限是否与当前请求相匹配
export function checklevel(data) {
    return request({
        url: 'apiuser/User/checkLevel',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 用户密码修改
export function changePwd(data) {
    return request({
        url: 'apiuser/User/changePwd',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 通过项目id获取项目ids
export function getIds(data) {
    return request({
        url: 'apiuser/Project/getIds',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取模版详情(分享)
export function getTempdelSh(params) {
    return request({
        url: '/apiuser/Template/shares',
        method: 'post',
        data: {
            ...params
        }
    })
}
// 根据id获取标签组件(分享)
export function getLblByIdSh(data) {
    return request({
        url: 'apiuser/ZuJianLbl/shares',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 根据id获取头尾组件(分享)
export function getTbByIdSh(data) {
    return request({
        url: 'apiuser/ZuJianTb/shares',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 用户申请试用
export function userapply(data) {
    return request({
        url: 'apiuser/User/applyTest',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取分享者的用户等级
export function getLevelByIds(data) {
    return request({
        url: 'apiuser/Project/getProjectUser',
        method: 'post',
        data: {
            ...data
        }
    })
}